module.exports = __webpack_public_path__ + "img/banner2.f9a53652.png";